<template>
  <div>
    <v-card
      style="width:100%;"
      class="d-flex justify-center"
      v-if="showMobileView"
    >
      <v-layout
        class="d-flex justify-center align-center"
        style="height:80px; width: 100%;"
      >
        <div class="d-flex align-center pl-5" style="width:100%; height:80px;">
          <h4
            style="color:gray; padding-right:4px;"
            @click="goBack()"
            class="go-back"
          >
            Account >
          </h4>
          <h4>Users</h4>
        </div>
      </v-layout>
    </v-card>
    <div class="d-flex flex-column">
      <filter-bar
        name="users"
        :filter="_getUsersFilter"
        v-if="!showMobileView"
      />

    </div>
    <div class="d-flex">
      <div
        v-if="currentClient.client_name && !this.showMobileView"
        style="min-width:20%;"
      >
        <account />
      </div>
      <div :style="formWidth" class="mt-4">
        <all-users />
      </div>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      id="edits-cancelled-snack"
    >
      {{ getUserError }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AllUsers from './AllUsers.vue';
import Account from '@/components/Account.vue';
import FilterBar from '@/components/app/FilterBar.vue';
import { MobileView } from '@/mixins';
import router from '../../router';

export default {
  components: {
    AllUsers,
    Account,
    FilterBar,
  },
  mixins: [MobileView],
  data: () => ({
    snackbar: false,
    snackbarText: false,
    timeout: 2000,
  }),
  computed: {
    ...mapGetters({
      currentClient: 'account/getCurrentClient',
      _getUsersFilter: 'filters/getUsersFilter',
      getUserError: 'account/getUserError',
    }),
    formWidth() {
      if (this.showMobileView) {
        return 'width:100%;';
      }
      return 'width:75%';
    },
  },
  methods: {
    ...mapMutations({
      _setNewInvite: 'account/setNewInvite',
      setUserError: 'account/setUserError',
    }),
    goBack() {
      router.push(
        `/${this.currentClient.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/account`,
      );
    },
  },
  watch: {
    getUserError() {
      if (this.getUserError) {
        this.snackbar = true;
      }
    },
    snackbar() {
      if (!this.snackbar) {
        this.setUserError(null);
      }
    },
  },
};
</script>

<style></style>
